import store from '../redux/store';

export function getThemeColor() {
  const storeInfo = store.getState().storeReducer.store;
  return storeInfo?.theme?.colors?.primary_color;
}
